import { render } from "./Scroll.vue?vue&type=template&id=1bc5d4a4&scoped=true"
import script from "./Scroll.vue?vue&type=script&lang=js"
export * from "./Scroll.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-1bc5d4a4"

export default script